export default "__VITE_ASSET__C7t4AeBA__"